export default __webpack_public_path__ + "media/images/blog/blog-06-370x250-8c2648197cbe48841bf15a5e85d4d827.jpg";